'use client';
import { styled } from '@mui/material/styles';
import MuiSkeleton, { SkeletonProps } from '@mui/material/Skeleton';

const StyledSkeleton = styled(MuiSkeleton)<SkeletonProps>({});

export const Skeleton = (props: SkeletonProps) => <StyledSkeleton {...props} />;
